import { render, staticRenderFns } from "./Puestos.vue?vue&type=template&id=e9d56a02&"
import script from "./Puestos.vue?vue&type=script&lang=js&"
export * from "./Puestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports